import React from 'react';
import { withTranslation } from 'react-i18next';

import { FullScreenExitIcon, FullScreenIcon } from '@icons';
import HomeBarButton from '@core/dashboard/components/HomeBarButton';

import { IFullScreenButton } from './interfaces';

const FullScreenButtonView = ({
  onClick,
  isFullscreen,
  t: translate,
}: IFullScreenButton) => {
  return (
    <HomeBarButton
      icon={isFullscreen ? <FullScreenExitIcon /> : <FullScreenIcon />}
      handleClick={onClick}
      label={
        isFullscreen
          ? translate('tooltips.fullscreenExit')
          : translate('tooltips.fullscreen')
      }
    />
  );
};

export default withTranslation('common')(FullScreenButtonView);
